import * as type from '../../../actions/index.types'

export function DocumentSeriesReducers(state = {
    loading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    previewLoading: false,
    documentSeriesData: null,
    documentSeriesDetails: null,
    previewNumber: null,
    pagination: null,
    error: null
}, action) {

    switch (action.type) {
        // Get Document Series
        case type.GET_DOCUMENT_SERIES:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_DOCUMENT_SERIES_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                documentSeriesData: action.payload?.data,
                pagination: action.payload?.meta?.pagination,
            }
        }
        case type.GET_DOCUMENT_SERIES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Get Document Series Details
        case type.GET_DOCUMENT_SERIES_DETAILS:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_DOCUMENT_SERIES_DETAILS_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                documentSeriesDetails: action.payload,
            }
        }
        case type.GET_DOCUMENT_SERIES_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Create Document Series
        case type.CREATE_DOCUMENT_SERIES:
            return {
                ...state,
                createLoading: true,
                error: null,
            }
        case type.CREATE_DOCUMENT_SERIES_SUCCESS: {
            return {
                ...state,
                error: null,
                createLoading: false,
            }
        }
        case type.CREATE_DOCUMENT_SERIES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            }

        // Update Document Series
        case type.UPDATE_DOCUMENT_SERIES:
            return {
                ...state,
                updateLoading: true,
                error: null,
            }
        case type.UPDATE_DOCUMENT_SERIES_SUCCESS: {
            return {
                ...state,
                error: null,
                updateLoading: false,
            }
        }
        case type.UPDATE_DOCUMENT_SERIES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                updateLoading: false,
            }

        // Delete Document Series
        case type.DELETE_DOCUMENT_SERIES:
            return {
                ...state,
                deleteLoading: true,
                error: null,
            }
        case type.DELETE_DOCUMENT_SERIES_SUCCESS: {
            return {
                ...state,
                error: null,
                deleteLoading: false,
            }
        }
        case type.DELETE_DOCUMENT_SERIES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                deleteLoading: false,
            }

        // Preview Document Series Number
        case type.PREVIEW_DOCUMENT_SERIES_NUMBER:
            return {
                ...state,
                previewLoading: true,
                error: null,
            }
        case type.PREVIEW_DOCUMENT_SERIES_NUMBER_SUCCESS: {
            return {
                ...state,
                error: null,
                previewLoading: false,
                previewNumber: action.payload,
            }
        }
        case type.PREVIEW_DOCUMENT_SERIES_NUMBER_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                previewLoading: false,
            }

        default:
            return state
    }
}
